import { createSelector } from 'reselect';
import {
    get, has,
} from 'lodash';

/**
 * Base Selectors
 */
const getAuth = (state) => get(state, 'app.auth', {});
const getAuthUser = (state) => get(state, 'app.database.authUser', {});
/**
 * Selector Builders
 */
export const buildAuthUserSelector = () => createSelector([getAuth, getAuthUser], (authState, authUsers) =>
{
    if (authState.user.id && has(authUsers, authState.user.id))
    {
        return authState.user;
    }

    return null;
});

export const buildAuthLoadingSelector = () => createSelector([getAuth], (authState) => authState.isLoading);
